import React from 'react'
import _ from 'lodash'

export class ItemReservationBlock extends React.Component {
    constructor(props) {
        super(props)
        this._showMe = false

        _.bindAll(this,
            'getBlock'
        )
    }

    getBlock(label, value) {
        if (value) {
            // We have at least one item so:
            this._showMe = true
            return (
                <div className="reservation-item">
                    <div className="reservation-item-label">{label}</div>
                    <div className="reservation-item-content">{value}</div>
                </div>
            )
        } else {
            return null
        }
    }

    render() {
        if (this.props.item) {
            // TODO: This may vary by model, starting with accoms
            let checkInDate = this.props.item.getIn(['reservation_details', 'checkin'])
            if (typeof(checkInDate) !== 'string') {
                checkInDate = checkInDate && typeof(checkInDate.format) === 'function' ? checkInDate.format('MM/DD/YYYY') : null
            }
            let checkin = this.getBlock('Check In', checkInDate)
            let checkOutDate = this.props.item.getIn(['reservation_details', 'checkout'])
            if (typeof(checkOutDate) !== 'string') {
                checkOutDate = checkOutDate && typeof(checkOutDate.format) === 'function' ? checkOutDate.format('MM/DD/YYYY') : null
            }
            let checkout = this.getBlock('Check Out', checkOutDate)
            let confirmation_code = this.getBlock('Confirmation Code', this.props.item.getIn(['reservation_details', 'confirmation_code']))
            let numguests = this.getBlock('Guests', this.props.item.getIn(['reservation_details', 'numguests']))
            let notes = this.getBlock('Notes', this.props.item.getIn(['reservation_details', 'notes']))

            // sepcific to travel
            let startdate = this.getBlock('Start Date', this.props.item.getIn(['reservation_details', 'startdate']))
            let starttime = this.getBlock('Start Time', this.props.item.getIn(['reservation_details', 'starttime']))
            let enddate = this.getBlock('End Date', this.props.item.getIn(['reservation_details', 'enddate']))
            let endtime = this.getBlock('End Time', this.props.item.getIn(['reservation_details', 'endtime']))
            let carrier = this.getBlock('Carrier', this.props.item.getIn(['reservation_details', 'carrier']))
            let transittype = this.getBlock('Transit Type', this.props.item.getIn(['reservation_details', 'transittype']))

            if (this._showMe) {
                return (
                    <div className="item-content-block">
                        <div className="item-content-label">
                            {this.props.label}
                        </div>
                        <div className="item-content-body">
                            {checkin}
                            {startdate}
                            {starttime}
                            {checkout}
                            {enddate}
                            {endtime}
                            {confirmation_code}
                            {carrier}
                            {transittype}
                            {numguests}
                            {notes}
                        </div>
                    </div>
                )
            } else {
                return null
            }
        } else {
            return null
        }
    }
}
